import React, { Suspense, lazy, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary.js'; // create this file (code below)

// Lazy-loaded pages
const Home = lazy(() => import('./pages/Home/Home'));
const About = lazy(() => import('./pages/About/About'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const ProductPage = lazy(() => import('./pages/ProductPage/ProductPage'));
const Login = lazy(() => import('./pages/Login/Login'));
const Register = lazy(() => import('./pages/Register/Register'));
const ForgetPassword = lazy(() => import('./pages/ForgetPassword/ForgetPassword'));
const Shop = lazy(() => import('./pages/shop/Shop'));
const Otp = lazy(() => import('./pages/Otp/Otp'));
const Cart = lazy(() => import('./pages/Cart/Cart'));
const CheckOut = lazy(() => import('./pages/Cart/CheckOut'));
const ReceiptComponent = lazy(() => import('./pages/Cart/Receipt'));
const Dashboard = lazy(() => import('./User_Dashboard/Dashboard'));
const Policy = lazy(() => import('./pages/Policy/Policy'));
const Support = lazy(() => import('./pages/Support/Support'));
const CategoryPage = lazy(() => import('./pages/Category_page/Category_page'));
const ProductSub = lazy(() => import('./pages/Category_page/Product_Sub'));
const BlogDetails = lazy(() => import('./pages/Blogs/BlogDetails'));
const SearchProduct = lazy(() => import('./pages/SearchProduct/SearchProduct'));
const CarBatteries = lazy(() => import('./pages/CarBatteries/CarBatteries'));
const InverterSolarBatteries = lazy(() => import('./pages/InverterSolarBatteries/InverterSolarBatteries'));
const BatteryInstallation = lazy(() => import('./pages/service-pages/BatteryInstallation'));
const OldBatteryExchange = lazy(() => import('./pages/service-pages/OldBatteryExchange'));
const WarrantySupport = lazy(() => import('./pages/service-pages/WarrantySupport'));

function App() {
  const location = useLocation();

  // Scroll to top on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
            <div className="w-12 h-12 border-4 border-red-600 border-t-transparent rounded-full animate-spin"></div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/productpage/:_id" element={<ProductPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgetpassword" element={<ForgetPassword />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/Verify-Otp" element={<Otp />} />
          <Route path="/Cart" element={<Cart />} />
          <Route path="/procced-to-checkout" element={<CheckOut />} />
          <Route path="/Receipt/order-confirmed" element={<ReceiptComponent />} />
          <Route path="/profile/dashboard" element={<Dashboard />} />
          <Route path="/pages/:page" element={<Policy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/Page/details/:id" element={<CategoryPage />} />
          <Route path="/Page/details/sub/:id" element={<ProductSub />} />
          <Route path="/battery-installation" element={<BatteryInstallation />} />
          <Route path="/old-battery-exchange" element={<OldBatteryExchange />} />
          <Route path="/warranty-support" element={<WarrantySupport />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/Search-Product" element={<SearchProduct />} />
          <Route path="/car-batteries" element={<CarBatteries />} />
          <Route path="/inverter-Solar-batteries" element={<InverterSolarBatteries />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;